
import { request } from './request'
export const startSpider = (data) => {
    const url = '/ocean/api/v1/spider/add'
    return request({
        method: 'post',
        url: url,
        data
    })
}